import firebase  from 'firebase/app'
import 'firebase/messaging'
import DB        from 'firebaseDir/generic-db'
import AppConfig from 'assets/app-data/app-config'

const messaging = firebase.messaging()
messaging.usePublicVapidKey('BLra60tTzfosHgNTh5fDWHiT8-eVuSYu4gVum9hQcsIpypVw9UmypKzkFk8Jn_hz05GhvasURg3CPruQa7fEYow')

messaging.getToken().then(token => {
  if(token) {
    sendTokenToServer(token)
  } else {
    setTokenSentToServer(false)
  }
}).catch(() => {
  setTokenSentToServer(false)
})

messaging.onTokenRefresh(() => {
  messaging.getToken().then((refreshedToken) => {
    setTokenSentToServer(false)
    sendTokenToServer(refreshedToken)
  }).catch(() => {
    setTokenSentToServer(false)
  })
})

function sendTokenToServer(token) {
  if(!isTokenSentToServer()) {
    const db  = new DB('fcmTokens')
    const id  = AppConfig.name
    const key = `${Date.parse(new Date().toString())}_${Math.ceil(Math.random() * 100000)}`
    db.update({
      id,
      [key]: token,
    })
    setTokenSentToServer(true)
  }
}

function isTokenSentToServer() {
  return window.localStorage.getItem('sentToServer') === '1'
}

function setTokenSentToServer(sent) {
  window.localStorage.setItem('sentToServer', sent ? '1' : '0')
}
